/**
 * Checks whether the given `obj` has all the given `keys`.
 * @param  {Object}  obj
 * @param  {Any[]}  keys
 * @returns {boolean}
 */
function hasKeysObjectUtil (obj, keys) {
  return keys.every(key => key in obj)
}

/**
 * Returns a copy of the given `object` with only promotives values.
 * NOTE: Nested object are ignored.
 * @param  {Object} object
 * @returns {Object}
 */
function getShallowObjectUtil (object) {
  return Object.keys(object).reduce((shallow, key) => {
    const value = object[key]
    if (typeof value !== 'object') {
      shallow[key] = value
    }
    return shallow
  }, {})
}

/**
 * Returns a copy of the given `object` without `null` or `undefined` values.
 * @param  {Object} obj
 * @returns {Object}
 */
function compactObjectUtil (obj) {
  return Object.keys(obj).reduce((newObj, key) => {
    const value = obj[key]
    if (value != null) {
      newObj[key] = value
    }
    return newObj
  }, {})
}

export {
  hasKeysObjectUtil,
  getShallowObjectUtil,
  compactObjectUtil
}
